import ApplicationModel, { attr } from '../ApplicationModel';
import { type AssistantArtifactAttributes } from './generated/AssistantArtifactAttributes';
import { model } from '../modelBuilder';

interface AssistantArtifact extends AssistantArtifactAttributes {}

@model
class AssistantArtifact extends ApplicationModel {
  // Start auto-generated
  static typename: 'AssistantArtifact' = 'AssistantArtifact';
  get typename(): 'AssistantArtifact' {
    return 'AssistantArtifact';
  }

  static internalTypename: 'Assistant::Artifact' = 'Assistant::Artifact';
  get internalTypename(): 'Assistant::Artifact' {
    return 'Assistant::Artifact';
  }

  static filterType = 'ArtifactFilters!';
  static filters = {
    id: '[ID!]',
    version: '[Int!]',
    fileName: '[String!]',
    chatId: 'ID',
  };

  static fields = {
    content: attr({ readable: true }),
    contentType: attr({ readable: true }),
    createdAt: attr({ readable: true }),
    fileName: attr({ readable: true }),
    id: attr({ readable: true }),
    summary: attr({ readable: true }),
    token: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    version: attr({ readable: true }),
    createdByUser: attr.belongsTo({ readable: true, typename: 'User' }),
  };
  // End auto-generated

  async regenerateToken() {
    await ApplicationModel.client.mutate(
      `mutation RegenerateAssistantArtifactToken($id: ID!) {
assistantArtifactRegenerateToken(id: $id) {
artifact {
token
}
}
}`,
      { variables: { id: this.id } }
    );
    return this.reload({
      query: AssistantArtifact.select('id', 'token'),
    });
  }

  get body() {
    return this.content;
  }

  get title() {
    return this.fileName || 'Artifact';
  }
}

export default AssistantArtifact;
